import { z } from 'zod';
/**
 * `noop` test job (spec 80 §8 sprint split): proves provider call, validation,
 * costing, budget and run log end to end without any domain effect. It has no
 * endpoint; only `AiJobsService.enqueue` starts it.
 */
export const noopInputSchema = z.object({
    text: z.string().min(1).max(2000),
});
export const noopOutputSchema = z.object({
    echo: z.string().max(2000),
    word_count: z.number().int().min(0),
});
//# sourceMappingURL=noop.js.map